import __vue_component__ from './WikiTable.vue.js';
import { WikiStructure } from './domain/types.js';
import { createInnerHtml, generateButton, generateNestedListTree, generateListTree, generateTable, generateImage, generateHeader } from './domain/generateWikiStructure.js';
import { defineComponent, h } from '@vue/composition-api';

var script = defineComponent({
    name: 'WikiStructured',
    props: {
        wiki: {
            type: Object,
            required: true,
        },
        htmlBlockIFrameHostWhitelist: {
            type: Array,
            required: false,
            default: undefined,
        },
    },
    setup: function (props) {
        return function () {
            return h('div', props.wiki.blocks.map(function (block) {
                switch (block.kind) {
                    case WikiStructure.Header:
                        return generateHeader(h, block);
                    case WikiStructure.Paragraph:
                        return h('p', createInnerHtml(block.text));
                    case WikiStructure.Image:
                        return generateImage(h, block);
                    case WikiStructure.Table:
                        return generateTable(h, block, __vue_component__);
                    case WikiStructure.List:
                        return generateListTree(h, block.items, block.style === 'ordered');
                    case WikiStructure.NestedList:
                        return generateNestedListTree(h, block.items, block.style === 'ordered');
                    case WikiStructure.Button:
                        return generateButton(h, block.url, block.text);
                    case WikiStructure.Html:
                        return h('div', createInnerHtml(block.content, props.htmlBlockIFrameHostWhitelist));
                    default:
                        return null;
                }
            }));
        };
    },
});

export default script;
